<template>
	<div class="animated fadeIn">
		<fixed-header title="Customer RMAs List" :records="pageInfo.totalItems" hideBackBtn hideNewOfferBtn>
			<add-crma class="mr-2" v-if="checkClaim(CAN_ADD_RMAS)" />
    </fixed-header>
		<div class="card">
			<div class="card-body">
				<div class="d-flex justify-content-start align-items-end mb-2">
          <b-form-group label="Status" class="mr-2">
            <b-form-select v-model="filters.statusId" @change="onSearch">
              <option :value="null">All</option>
              <option v-for="option in sortSelect(rmaStatuses)" :key="option.name" :value="option.id">
                {{option.name}}</option>
            </b-form-select>
				</b-form-group>
				<b-form-group label="RMA Number" class="mr-2">
					<b-form-input type="number" v-model="filters.rmaNo" @input="onSearch" size="sm" />
				</b-form-group>
				<b-form-group label="Invoice Number" class="mr-2">
					<b-form-input type="number" v-model="filters.invoiceNo" @input="onSearch" size="sm" />
				</b-form-group>
				<b-form-group label="Customer" class="mr-2">
					<b-form-input v-model="filters.companyName"  @input="onSearch" size="sm" />
				</b-form-group>
				<b-form-group label="Needs auth" class="mr-2" style="margin-bottom: 5px;">
					<b-form-checkbox v-model="filters.needsAuthorization" :indeterminate.sync="filters.needsAuthorization == null" @input="onSearch" />
				</b-form-group>
				<b-form-group label="Sales Rep" class="mr-2">
					<b-form-select v-model="filters.salesPersonUserId" @change="onSearch">
						<option :value="null">All</option>
						<option
							v-for="(selectRep, indexRep) in sortSelect(salesReps)"
							:key="indexRep"
							:value="selectRep.id"
						>{{ selectRep.name }}</option>
					</b-form-select>
				</b-form-group>
				<date-range-picker :dateFrom="filters.dateFrom" :dateTo="filters.dateTo" @handleSearch="onSearch"></date-range-picker>
				<b-button class="mr-2" size="sm" @click="clearFilter">Clear</b-button>
				</div>
        <grid-component
					isResizable
					isReorderable
					isSortable
          :canEdit="checkClaim(CAN_EDIT_RMAS)"
          :canDelete="checkClaim(CAN_DELETE_RMAS)"
					:gridId="gridId"
					:pageable="pageable"
					:skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
					:take="pageInfo.pageSize"
					:itemData="itemData"
					:pageSizes="pageInfo.pageSize"
					:totalItems="pageInfo.totalItems"
					:fields="fields"
					:sortBy="pageInfo.sortBy"
					:sortOrder="pageInfo.sortOrder"
					:sortMethod="sortGrid"
					:onEdit="onEdit"
					:onDelete="onDelete"
					:handleRowClick="onRowClick"
					:styleCustom="'height: 335px'"
					@getData="onGetData"
          :isTblLoader="tblLoader"
					/>
			</div>
		</div>
		<b-card>
			<div class="d-flex">
      </div>
			<b-tabs>
				<b-tab active>
          <template v-slot:title>
            Customer RMA Items &nbsp;<b-badge variant="primary">{{ customerRMALines.length }}</b-badge>
          </template>
					<b-row class="mb-2">
						<b-col>
							<b-button size="sm" variant="primary" v-b-modal.create-vrma-from-rma class="mr-2"
								:disabled="Object.keys(customerRMALine).length == 0 || !rmaSelected.isAuthorized">
								<i class="fa fa-plus" aria-hidden="true"></i>
								Create V-RMA
							</b-button>
							<b-button size="sm" variant="primary" class="mr-2"
								:disabled="isSavingInspection || Object.keys(customerRMALine).length == 0 || !rmaSelected.isAuthorized" @click="onCreationRmaInspection">
								<i v-show="isSavingInspection" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
								Create RMA Inspection
							</b-button>
							<b-button size="sm" variant="primary" :disabled="Object.keys(customerRMALine).length == 0 || !rmaSelected.isAuthorized"
								@click="$refs['rma-ncm-modal'].show()">
								Create NCM
							</b-button>
							<pending-vrma-view :vendorId="customerRMALine.vendorId" :rmaLine="customerRMALine"  />
							<b-modal
								id="rma-inspection-modal"
								ref="rma-inspection-modal"
								size="xl"
								hide-footer
								header-close-label="Cancel"
								:title="`Manage Report - RMA Inspection`"
								scrollable
							>
								<add-form-wizard :reportName="'RmaInspection'"
									:inventoryDetails="{...customerRMALine, quantitySold: customerRMALine.qtyReturning}"
									:inspectionDetails="inspectionDetails"
									:onRmaInspection="true" />
							</b-modal>
							<ncm-report-component :modalId="'rma-ncm-modal'" ref="rma-ncm-modal" :rmaLineProp="customerRMALine" />
						</b-col>
					</b-row>
					<customer-rma-lines
						:customerRMAId="selectedRowItemId"
						@showEdit="showEdit"
						@showDelete="showDeleteRmaLine"
						@selectedCustomerRMALine="setCustomerRMALine"
						isRMAListing />
				</b-tab>
			</b-tabs>
		</b-card>
		<rma-part-view :isAddPart="false" :rmaId="selectedRowItemId" :rmaPart="onEditRMAPart" @onRefresh="getCustomerRMALines(this.selectedRowItemId)" />
	</div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import { debounce, unionBy } from 'lodash';
import FixedHeader from '@/shared/components/FixedHeader/indexNew';
import AddCrma from '@/pages/Customerrmas/components/add';
import CustomerRmaLines from '@/pages/Customerrmas/components/CustomerrmasLines';
import { GRID_PAGE_SIZES, PAGE_SIZE, GRID_ID, REQUEST_DATE, SEARCH_DEBOUNCE_TIME } from '@/shared/constants';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import RmaPartView from '@/pages/Customerrmas/components/RmaParts';
import DateRangePicker from '@/shared/components/DateRangePicker/IndexNew';
import gridFields from './fields';
import AddFormWizard from '@/shared/components/InspectionReport/components/Form/AddFormWizard';
import PendingVrmaView from '@/pages/Vendorrmas/components/add/RmaModal';
import NcmReportComponent from '@/pages/NonconformanceReport/components/Form'

export default {
  components: {
		FixedHeader,
		AddCrma,
		CustomerRmaLines,
		GridSettings,
		DateRangePicker,
		GridComponent,
		RmaPartView,
		PendingVrmaView,
		NcmReportComponent,
		AddFormWizard
  },
  metaInfo: () => ({
    title: 'Customer RMAs',
  }),
	data() {
		return {
		  fields: gridFields,
			gridId: GRID_ID.CUSTOMERRMAS,
			modalId: 'rma-part-modal',
			pageable: {
				pageSizes: GRID_PAGE_SIZES,
			},
			requestDate: REQUEST_DATE,
			selectedRowItemId: 0,
			customerRMALine: {},
			onEditRMAPart: {},
			requiredPutFields: [
				'qtyReturning', 'rmaReasonId'
			],
			isSavingInspection: false,
			rmaSelected: {},
			inspectionDetails: {}
		};
	},
	computed: {
		...mapGetters('customerrmas', [
		  'gridList',
			'pageInfo',
			'filters',
      'lastOpenedId',
      'tblLoader'
		]),
		...mapGetters('account', ['gridSettingsById']),
		...mapState('salesReps', ['salesReps']),
		...mapGetters('lookup', ['rmaStatuses']),
		...mapGetters('customerRmasLines', ['customerRMALines']),
    gridSettings() {
			return this.gridSettingsById(this.gridId);
		},
		itemData() {
      if (this.gridList == undefined || !this.gridList.length) return [];
			return this.gridList.map((customerrma) => ({ ...customerrma, selected: customerrma.id === this.selectedRowItemId }));
		},
		isSaveEnable() {
			return this.validateRequiredFields();
		}
	},
	methods: {
    ...mapMutations('customerrmas',['setItem']),
		...mapActions('customerrmas', ['getAll', 'sortGrid', 'getPage', 'search', 'deleteRecord', 'onUpdateRMALine', 'onDeleteRMALine']),
		...mapActions('customerRmasLines', ['getCustomerRMALines', 'createRmaInspection']),
		...mapActions('salesReps', ['getSalesReps']),
    async onGetData(params) {
      await this.getAll(params);
		},
    onSearch: debounce(function(data = false) {
      if(typeof data === 'object') { Object.assign(this.filters,data) }
      this.search(this.filters);
    }, SEARCH_DEBOUNCE_TIME),

    clearFilter(callSearch = true) {
      this.clearObject(this.filters);
      if (callSearch) {
        this.search(this.filters);
      }
    },
		onRowClick(row) {
			this.rmaSelected = row.dataItem;
			this.selectedRowItemId = row.dataItem.id;
		},
		onEdit(row) {
      this.setItem({ resource: 'lastOpenedId', payload: row.id });
			this.$router.push({
				name: 'customerrmas.edit',
				params: { id: row.id },
			});
		},
		async onDelete(rma) {
			this.selectedRowItemId = rma.id;
      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete RMA #${rma.id}?`});
      if (deleteConfirmed) {
				const response = await this.deleteRecord(rma.id);

				if(response != undefined && response.status == 200) {
					this.selectedRowItemId = this.selectedRowItemId != rma.id ? this.selectedRowItemId : 0;
					this.getAll({});
				}
        	
			}
		},
		showEdit($e) {
			console.log($e, 'Test')
			this.onEditRMAPart = $e;
			this.$bvModal.show(this.modalId);
		},
		setCustomerRMALine(customerRMALine) {
      if(customerRMALine){
        this.customerRMALine = customerRMALine;
      }
		},
		onClear() {
			this.customerRMALine = {};
		},
		validateRequiredFields() {
			let requiredFields = this.requiredPutFields;
			let objFormProps = this.onEditRMAPart;

			for (let i = 0; i < requiredFields.length; i++) {
				let field = requiredFields[i];
				if (objFormProps[field] == undefined || objFormProps[field] == null) {
					return false;
					break;
				}
			}
			return true;
		},
		async saveRMALine() {
			if (this.validateRequiredFields) {
				await this.onUpdateRMALine({
					rmaId: this.selectedRowItemId,
					rmaLineId: this.onEditRMAPart.id,
					rmaLineDto: this.onEditRMAPart
				});

				this.onClear();
				this.$snotify.success('Saved RMA Line', 'Customer RMA');
				this.$bvModal.hide(this.modalId);
				this.getCustomerRMALines(this.selectedRowItemId);

			} else {
				this.$snotify.error('Please supply required fields', 'Customer RMA');
			}
		},
		async showDeleteRmaLine(row) {
      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete this RMA Line for Rma Line Id #${row.id}?`,headerClass: 'deleteDlg',});
			if(deleteConfirmed){
        const result = await this.onDeleteRMALine({
          rmaId: this.selectedRowItemId,
          rmaLineId: row.id
				});
				if (result.status == 200) {
					this.onClear();
        	this.getCustomerRMALines(this.selectedRowItemId);
        	this.$snotify.success('Deleted RMA Line', 'Customer RMA');
				}
        
      }
		},
    async onCreationRmaInspection() {
      try {
        this.isSavingInspection=true;
        let resData = await this.createRmaInspection({line: this.customerRMALine, userId: this.userId});
        this.isSavingInspection = false;
        if(resData.id) {
          this.inspectionDetails = resData;
          this.$bvModal.show('rma-inspection-modal');
        }
      } catch {
        this.isSavingInspection= false;
      }
    }
	},
	watch: {
		gridList() {
			//This function sets the first row as the selected row
			this.selectedRowItemId = this.setSelectedRowId(this.gridList,this.selectedRowItemId,this.lastOpenedId);
      if (this.selectedRowItemId > 0) {
				this.rmaSelected = this.itemData.find(x => x.id == this.selectedRowItemId)
			}
		},
	},
	async mounted() {
    if('clear' in this.$route.query) {
      this.pageInfo.pageNumber = 1;
      this.clearFilter(false);
      this.clearRoute();
    } else {

      if('statisticFilter' in this.$route.params && this.$route.params.statisticFilter){
        this.clearObject(this.filters);
      }

      if('needsAuthorization' in this.$route.params && this.$route.params.needsAuthorization) {
        this.filters.needsAuthorization = true;
        delete this.$route.params.needsAuthorization;
      }
      if('statisticFilter' in this.$route.params && this.$route.params.statisticFilter) {
        this.search(this.filters);
        delete this.$route.params.statisticFilter;
      }else {
        this.setItem({
          resource: 'pageInfo',
          payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize}
        });
        await this.getAll({});
      }
      this.getSalesReps();
    }
	},
  destroyed() {

  }
};
</script>
